export default __webpack_public_path__ + "e8ff3bce129a45fb6bac2286daca3a92.svg";